/**
 * Авторизация психологов
 * Email/пароль авторизация с восстановлением пароля
 * Поддерживает попап-форму и встроенную форму на странице
 */
const PsyAuth = {
	moduleId: null,

	/**
	 * Инициализация
	 */
	init: function() {
		// Получаем ID модуля из попапа или из встроенной формы на странице
		var popup = document.getElementById('popup-psy-auth');
		if (popup && popup.dataset.moduleId) {
			this.moduleId = popup.dataset.moduleId;
		}

		// Также проверяем встроенную форму (на страницах профиля/расписания)
		if (!this.moduleId) {
			var inlineContainer = document.querySelector('[data-psy-auth-module-id]');
			if (inlineContainer) {
				this.moduleId = inlineContainer.dataset.psyAuthModuleId;
			}
		}

		this.bindEvents();
	},

	/**
	 * Привязка событий
	 */
	bindEvents: function() {
		var self = this;

		// Открытие попапа входа
		document.querySelectorAll('[data-psy-auth-open]').forEach(function(el) {
			el.addEventListener('click', function(e) {
				e.preventDefault();
				self.openLoginPopup();
			});
		});

		// Закрытие попапов
		document.querySelectorAll('.popup-psy-auth .popup__close, .popup-psy-auth .popup__overlay').forEach(function(el) {
			el.addEventListener('click', function() {
				self.closePopups();
			});
		});

		// ——— Попап-формы ———

		var popupLoginForm = document.getElementById('psy-auth-login-form');
		if (popupLoginForm) {
			popupLoginForm.addEventListener('submit', function(e) {
				e.preventDefault();
				self.login(popupLoginForm, 'popup');
			});
		}

		var popupForgotForm = document.getElementById('psy-auth-forgot-form');
		if (popupForgotForm) {
			popupForgotForm.addEventListener('submit', function(e) {
				e.preventDefault();
				self.requestPasswordReset(popupForgotForm, 'popup');
			});
		}

		// ——— Встроенные формы (на страницах кабинета) ———

		var inlineLoginForm = document.getElementById('psy-auth-inline-form');
		if (inlineLoginForm) {
			inlineLoginForm.addEventListener('submit', function(e) {
				e.preventDefault();
				self.login(inlineLoginForm, 'inline');
			});
		}

		var inlineForgotForm = document.getElementById('psy-auth-inline-forgot-form');
		if (inlineForgotForm) {
			inlineForgotForm.addEventListener('submit', function(e) {
				e.preventDefault();
				self.requestPasswordReset(inlineForgotForm, 'inline');
			});
		}

		// ——— Ссылки «Забыли пароль?» и «Вернуться к входу» ———

		document.querySelectorAll('[data-psy-auth-forgot]').forEach(function(el) {
			el.addEventListener('click', function(e) {
				e.preventDefault();
				// Определяем контекст: попап или встроенная форма
				var ctx = self.getContext(el);
				self.showForgotForm(ctx);
			});
		});

		document.querySelectorAll('[data-psy-auth-back-to-login]').forEach(function(el) {
			el.addEventListener('click', function(e) {
				e.preventDefault();
				var ctx = self.getContext(el);
				self.showLoginForm(ctx);
			});
		});

		// Кнопка выхода
		document.querySelectorAll('[data-psy-auth-logout]').forEach(function(el) {
			el.addEventListener('click', function(e) {
				e.preventDefault();
				self.logout();
			});
		});

		// Закрытие по Escape
		document.addEventListener('keydown', function(e) {
			if (e.key === 'Escape') {
				self.closePopups();
			}
		});
	},

	/**
	 * Определяет контекст формы: 'popup' или 'inline'
	 */
	getContext: function(el) {
		if (el.closest('.popup-psy-auth')) {
			return 'popup';
		}
		return 'inline';
	},

	/**
	 * Открытие попапа входа
	 */
	openLoginPopup: function() {
		var popup = document.getElementById('popup-psy-auth');
		if (popup) {
			popup.classList.add('active');
			this.showLoginForm('popup');
			setTimeout(function() {
				var emailInput = popup.querySelector('input[name="email"]');
				if (emailInput) emailInput.focus();
			}, 100);
		}
	},

	/**
	 * Закрытие попапов
	 */
	closePopups: function() {
		document.querySelectorAll('.popup-psy-auth').forEach(function(popup) {
			popup.classList.remove('active');
		});
		this.clearErrors();
	},

	/**
	 * Показать форму входа
	 */
	showLoginForm: function(ctx) {
		this.clearErrors();

		if (ctx === 'popup') {
			var loginStep = document.getElementById('psy-auth-login-step');
			var forgotStep = document.getElementById('psy-auth-forgot-step');
			var successStep = document.getElementById('psy-auth-success-step');

			if (loginStep) loginStep.style.display = 'block';
			if (forgotStep) forgotStep.style.display = 'none';
			if (successStep) successStep.style.display = 'none';
		} else {
			// Inline формы
			var inlineLogin = document.getElementById('psy-auth-inline-form');
			var inlineForgot = document.getElementById('psy-auth-inline-forgot');
			var inlineSuccess = document.getElementById('psy-auth-inline-success');

			// Показываем форму входа и заголовки
			if (inlineLogin) inlineLogin.style.display = 'block';
			if (inlineForgot) inlineForgot.style.display = 'none';
			if (inlineSuccess) inlineSuccess.style.display = 'none';

			// Показываем заголовок и текст, если скрыты
			var authBlock = document.querySelector('.psy-cabinet__auth');
			if (authBlock) {
				var title = authBlock.querySelector('.psy-cabinet__title');
				var text = authBlock.querySelector('.psy-cabinet__text');
				if (title) title.style.display = '';
				if (text) text.style.display = '';
			}
		}
	},

	/**
	 * Показать форму восстановления пароля
	 */
	showForgotForm: function(ctx) {
		this.clearErrors();

		if (ctx === 'popup') {
			var loginStep = document.getElementById('psy-auth-login-step');
			var forgotStep = document.getElementById('psy-auth-forgot-step');
			var successStep = document.getElementById('psy-auth-success-step');

			if (loginStep) loginStep.style.display = 'none';
			if (forgotStep) forgotStep.style.display = 'block';
			if (successStep) successStep.style.display = 'none';

			setTimeout(function() {
				var emailInput = document.querySelector('#psy-auth-forgot-form input[name="email"]');
				if (emailInput) emailInput.focus();
			}, 100);
		} else {
			// Inline формы
			var inlineLogin = document.getElementById('psy-auth-inline-form');
			var inlineForgot = document.getElementById('psy-auth-inline-forgot');
			var inlineSuccess = document.getElementById('psy-auth-inline-success');

			if (inlineLogin) inlineLogin.style.display = 'none';
			if (inlineForgot) inlineForgot.style.display = 'block';
			if (inlineSuccess) inlineSuccess.style.display = 'none';

			// Скрываем общий заголовок/текст, т.к. у forgot свой заголовок
			var authBlock = document.querySelector('.psy-cabinet__auth');
			if (authBlock) {
				var title = authBlock.querySelector('.psy-cabinet__title');
				var text = authBlock.querySelector('.psy-cabinet__text');
				if (title) title.style.display = 'none';
				if (text) text.style.display = 'none';
			}

			setTimeout(function() {
				var emailInput = document.querySelector('#psy-auth-inline-forgot-form input[name="email"]');
				if (emailInput) emailInput.focus();
			}, 100);
		}
	},

	/**
	 * Показать сообщение об успешной отправке пароля
	 */
	showSuccessMessage: function(message, ctx) {
		if (ctx === 'popup') {
			var loginStep = document.getElementById('psy-auth-login-step');
			var forgotStep = document.getElementById('psy-auth-forgot-step');
			var successStep = document.getElementById('psy-auth-success-step');
			var successMessage = document.getElementById('psy-auth-success-message');

			if (loginStep) loginStep.style.display = 'none';
			if (forgotStep) forgotStep.style.display = 'none';
			if (successStep) successStep.style.display = 'block';
			if (successMessage) successMessage.textContent = message;
		} else {
			var inlineLogin = document.getElementById('psy-auth-inline-form');
			var inlineForgot = document.getElementById('psy-auth-inline-forgot');
			var inlineSuccess = document.getElementById('psy-auth-inline-success');
			var inlineSuccessMessage = document.getElementById('psy-auth-inline-success-message');

			if (inlineLogin) inlineLogin.style.display = 'none';
			if (inlineForgot) inlineForgot.style.display = 'none';
			if (inlineSuccess) inlineSuccess.style.display = 'block';
			if (inlineSuccessMessage) inlineSuccessMessage.textContent = message;

			// Скрываем общий заголовок/текст
			var authBlock = document.querySelector('.psy-cabinet__auth');
			if (authBlock) {
				var title = authBlock.querySelector('.psy-cabinet__title');
				var text = authBlock.querySelector('.psy-cabinet__text');
				if (title) title.style.display = 'none';
				if (text) text.style.display = 'none';
			}
		}
	},

	/**
	 * Вход
	 */
	login: function(form, ctx) {
		var self = this;
		var email = form.querySelector('input[name="email"]').value.trim();
		var password = form.querySelector('input[name="password"]').value;
		var submitBtn = form.querySelector('button[type="submit"]');

		if (!email || !password) {
			this.showError('Введите email и пароль', form);
			return;
		}

		this.clearErrors();
		this.setLoading(submitBtn, true);

		this.ajax('login', { email: email, password: password })
			.then(function(res) {
				if (res.success) {
					self.onAuthSuccess(ctx);
				} else {
					self.showError(res.error || 'Ошибка авторизации', form);
				}
			})
			.catch(function() {
				self.showError('Ошибка соединения', form);
			})
			.finally(function() {
				self.setLoading(submitBtn, false);
			});
	},

	/**
	 * Запрос восстановления пароля
	 */
	requestPasswordReset: function(form, ctx) {
		var self = this;
		var email = form.querySelector('input[name="email"]').value.trim();
		var submitBtn = form.querySelector('button[type="submit"]');

		if (!email) {
			this.showError('Введите email', form);
			return;
		}

		this.clearErrors();
		this.setLoading(submitBtn, true);

		this.ajax('forget', { email: email })
			.then(function(res) {
				if (res.success) {
					self.showSuccessMessage(res.message || 'Временный пароль отправлен на email', ctx);
				} else {
					self.showError(res.error || 'Ошибка отправки', form);
				}
			})
			.catch(function() {
				self.showError('Ошибка соединения', form);
			})
			.finally(function() {
				self.setLoading(submitBtn, false);
			});
	},

	/**
	 * Выход
	 */
	logout: function() {
		this.ajax('logout')
			.then(function(res) {
				if (res.success) {
					window.location.reload();
				}
			});
	},

	/**
	 * Проверка авторизации
	 */
	checkAuth: function(callback) {
		this.ajax('check')
			.then(function(res) {
				if (callback) callback(res.authenticated, res.person);
			});
	},

	/**
	 * Успешная авторизация
	 */
	onAuthSuccess: function(ctx) {
		this.closePopups();
		// Перезагрузка текущей страницы — покажет контент вместо формы
		window.location.reload();
	},

	/**
	 * AJAX запрос
	 */
	ajax: function(action, data) {
		data = data || {};
		var formData = new FormData();
		formData.append('action', action);

		for (var key in data) {
			if (data.hasOwnProperty(key)) {
				formData.append(key, data[key]);
			}
		}

		return fetch('/ajax.php?mid=' + this.moduleId, {
			method: 'POST',
			body: formData
		}).then(function(res) { return res.json(); });
	},

	/**
	 * Показать ошибку рядом с формой
	 */
	showError: function(message, form) {
		var errorEl;

		if (form) {
			// Ищем .psy-auth__error в том же контейнере, что и форма
			var parent = form.parentElement;
			if (parent) {
				errorEl = parent.querySelector('.psy-auth__error');
			}
		}

		// Запасной вариант: ищем в активном попапе
		if (!errorEl) {
			errorEl = document.querySelector('.popup-psy-auth.active .psy-auth__error');
		}

		// Запасной вариант 2: ищем во встроенной форме
		if (!errorEl) {
			errorEl = document.querySelector('.psy-cabinet--auth .psy-auth__error');
		}

		if (errorEl) {
			errorEl.textContent = message;
			errorEl.style.display = 'block';
		}
	},

	/**
	 * Очистить ошибки
	 */
	clearErrors: function() {
		document.querySelectorAll('.psy-auth__error').forEach(function(el) {
			el.textContent = '';
			el.style.display = 'none';
		});
	},

	/**
	 * Установить состояние загрузки
	 */
	setLoading: function(button, loading) {
		if (!button) return;

		if (loading) {
			button.disabled = true;
			button.dataset.originalText = button.textContent;
			button.textContent = 'Загрузка...';
		} else {
			button.disabled = false;
			button.textContent = button.dataset.originalText || button.textContent;
		}
	}
};

// Инициализация при загрузке DOM
$(document).ready(function() {
	PsyAuth.init();
});

// Экспорт
window.PsyAuth = PsyAuth;
